<template>
  <fragment>
    <b-button @click="onShowModal"
              btn-text="Edit"
              :disabled="classroomExchangeExpired"
              class="btn-edit"/>
    <modal id="edit-student-modal">
      <template #body>
        <b-overlay :show="sendingData" rounded="sm">
          <template #overlay>
            <div class="text-center">
              <p id="cancel-label">Please wait...</p>
              <b-spinner label="Spinning"/>
            </div>
          </template>
          <h2 class="modal-title">EDIT STUDENT NAME</h2>
          <p class="modal-label">First Name</p>
          <form-Input type="text"
                      :maxlength="25"
                      v-model="$v.form.first_name.$model"
                      :validator="$v.form.first_name"
                      custom-class="common-input common-input--primary"
                      placeholder="First Name *"/>
          <p class="modal-label">Last Initial</p>
          <form-input type="text"
                      :maxlength="1"
                      v-model="$v.form.last_initial.$model"
                      :validator="$v.form.last_initial"
                      custom-class="common-input common-input--primary"
                      placeholder="Last Initial *"/>
        </b-overlay>
      </template>
      <template #footer>
        <b-button @click="$bvModal.hide('edit-student-modal')" btn-text="CANCEL"/>
        <b-button @click="addStudent()" btn-text="SAVE" :disabled="sendingData"/>
      </template>
    </modal>
  </fragment>
</template>

<script>
import {ClassroomService} from "@/core/Services";
import {Modal} from "@/core/components/Modal";
import {Button} from "@/core/components/Button";
import FormInput from "@/core/components/Form/Input"
import {required, alpha, maxLength} from "vuelidate/lib/validators"
import {ExchangesMixins} from "@/modules/MyClassrooms/Mixins"

export default {
  name: "ClassroomDetailStudentEdit",
  mixins: [ExchangesMixins],
  components: {
    Modal,
    FormInput,
    'b-button': Button,
  },
  data() {
    return {
      form: {
        first_name: '',
        last_initial: '',
      },
      sendingData: false
    }
  },
  props: {
    classroom: Object,
    student: Object
  },
  validations() {
    return {
      form: {
        first_name: {
          required,
          alpha,
          maxLength: maxLength(25)
        },
        last_initial: {
          required,
          alpha,
          maxLength: maxLength(1)
        }
      }
    }
  },
  methods: {
    addStudent() {
      this.$v.$touch()
      if (this.$v.form.first_name.$anyError || this.$v.form.last_initial.$anyError) {
        return
      }
      this.sendingData = true
      ClassroomService.editStudentName({
        classroom_id: this.classroom.id,
        form: {...this.form}, student_id:
        this.student.id})
      .then(() => {
        this.$bvModal.msgBoxOk('Success!', {
          size: 'sm',
          dialogClass: "modal-message-box",
          noCloseOnBackdrop: true,
          centered: true
        }).then(() => {
          this.$v.$reset()
          this.$emit('on-edit-student-name', {...this.form})
          this.$bvModal.hide('edit-student-modal')
        })
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          size: 'sm',
          dialogClass: "modal-message-box",
          noCloseOnBackdrop: true,
          centered: true
        })
      })
      .finally(() => this.sendingData = false)
    },
    onShowModal() {
      this.form =  {
        first_name: this.student.first_name,
        last_initial: this.student.last_initial,
      }
      this.$bvModal.show('edit-student-modal')
    }
  }
}
</script>

<style lang="stylus" scoped>
.btn-edit
  min-width 0
  font-size 13px
  margin-left 28px
  @media(max-width 500px)
    margin-left 0
    margin 10px 0

.modal-label
  font-size 16px
  margin-bottom 10px
</style>
